import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';
import BGVideo from '../layout/BGVideo';

class ScrollItem__Header extends VScroll_Item {
  timeline;
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.body = GetBy.class("__title", this.item)[0];

    this.onMove = () => {
      let alpha = 0;
      
      if(this.progress < .5) {
        alpha = Maths.normalize(0.3, 0.2, this.progress);
        this.body.style.opacity = Maths.normalize(0.4, 0.3, this.progress);
      } else {
        alpha = Maths.normalize(0.6, 0.8, this.progress);
        this.body.style.opacity = Maths.normalize(0.6, 0.7, this.progress);
      }     
    }
  }
}

Scroll._registerClass('header', ScrollItem__Header);